import React, { createContext, useContext, useState } from 'react';

type Language = 'es' | 'en';

interface LanguageContextValue {
  language: Language;
  setLanguage: (lang: Language) => void;
  showWarning: boolean;
  dismissWarning: () => void;
}

const LanguageContext = createContext<LanguageContextValue>({
  language: 'es',
  setLanguage: () => {},
  showWarning: false,
  dismissWarning: () => {},
});

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // DEV NOTE: prototype default is 'es'.
  // Production default: 'en' — derive from Contest.config or user browser preference.
  const [language, setLanguageState] = useState<Language>('es');
  const [showWarning, setShowWarning] = useState(false);

  const setLanguage = (lang: Language) => {
    if (lang === 'es' && language === 'en') {
      setShowWarning(true);
    } else if (lang === 'en') {
      // Al cambiar a inglés el aviso de "redactar en inglés" es redundante:
      // se descarta igual que al presionar "Entendido".
      setShowWarning(false);
    }
    setLanguageState(lang);
  };

  const dismissWarning = () => setShowWarning(false);

  return (
    <LanguageContext.Provider
      value={{ language, setLanguage, showWarning, dismissWarning }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
